import { Locale } from 'modules/i18n';

export const consensusSwitchTranslation = {
  [Locale.en]: {
    beacon: 'Beacon',
    opnode: 'Op-node',
  },
};
